import Navbar from "@/components/layout/navbar";
import CreateProfile from "@/features/user/pages/create-profile";
import { useAuth } from "@/hooks/use-auth";
import { Outlet } from "react-router";

const HomeLayout = () => {
  const auth = useAuth();

  return (
    <section className="w-full min-h-screen bg-black sm:px-10 px-2 relative overflow-hidden">
      <div
        className="fixed inset-0 w-full h-full z-0"
        style={{
          backgroundImage: `url("https://imagedelivery.net/LQsry4VlRw5rN4KvSzkcLw/af6c2b7e-c72b-4f30-bdfb-01a54a6a6c00/public")`,
          backgroundPosition: "center center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      />
      <div className="fixed inset-0 bg-black/20 pointer-events-none z-10" />
      <div className="relative z-20 min-h-screen">
        <Navbar />
        {auth.isProfileCreated ? <Outlet /> : <CreateProfile />}
      </div>
    </section>
  );
};

export default HomeLayout;
